import { GzAntimalwareSecurityServersWebComponent } from './component/GzAntimalwareSecurityServersWebComponent';

export { GzAntimalwareSecurityServersWebComponent };
